var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":_vm.indeterminate,"size":_vm.size||32}}),_c('div',[_vm._v(_vm._s(_vm.text || _vm.$t('loading.text')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }